export default "__VITE_ASSET__B10zNM$$__"